module.exports = {
  'fast-1': '70ms',
  'fast-2': '110ms',
  'moderate-1': '150ms',
  'moderate-2': '240ms',
  'slow-1': '400ms',
  'slow-2': '700ms'
}
